import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Api from "../../state/Api";
import { Paper , Button , Box, FormControl, Switch, FormControlLabel, InputLabel, TextField, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import * as appActions from '../../state/app/actions';
import * as campaignsSelector from '../../state/channels/selectors';

const useStyles = makeStyles(theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginRight: theme.spacing(1),
      width: 200,
    },
    cien : { 
        width : '100%'
    },
    mBottom : { 
        marginBottom : '20px'
    }, 
    configPaper : {
        padding: '10px',
        marginBottom : '10px'
    }
}));


const ConfigOptions = () => {
    const dispatch = useDispatch();
    const [couponActive, setCouponActive] = React.useState(false);
    const [enabled, setEnabled] = React.useState(false);
    const [forceOpen, setForceOpen] = React.useState(false);
    const [visible, setVisible] = React.useState(false);
    const [appid, setAppid] = React.useState('');
    const [contentUrl, setContentUrl] = React.useState('');
    const [couponCode, setCouponCode] = React.useState('');
    const [showCoupon, setShowCoupon] = React.useState('');
    const [chatLayout, setChatLayout] = React.useState('');
    const [collectionId, setCollectionId] = React.useState('');
    const isAdmin = useSelector(campaignsSelector.isLiveShoppingAdmin());

    const classes = useStyles();
    
    const setConfigValues = (values) => {
        setShowCoupon(values.showCoupon)
        setEnabled(values.enabled)
        setForceOpen(values.forceOpen);
        setVisible(values.visible);
        setContentUrl(values.contentUrl);
        setCouponCode(values.couponCode)
        setChatLayout(values.chatLayout)
        setCollectionId(values.collectionid)
        setAppid(values.appid)
        dispatch(appActions.setCurrentStream(values.contentUrl))
    }

    const guardarCambios = () => {
        
        let datos = {
            couponCode: couponCode,
            showCoupon: showCoupon,
            collectionid: collectionId,
            contentUrl: contentUrl,
            chatLayout: chatLayout,
            forceOpen: forceOpen,
            visible: visible
        }

        
        Api.req.put(`https://live.tevecompras.com/api/live-shopping/cfg`, datos)
            .then((response) => {
               dispatch(appActions.addToast('Se han guardado los cambios'))

        })
    }

    useEffect(() => {
        Api.req.get(`https://live.tevecompras.com/api/live-shopping/cfg`)
            .then((response) => {
                setConfigValues(response.data.data[0])
              
            })
    }, [])
    
    return (
    
    <div style={{padding : '10px'}}>
        <Paper elevation={2} className={classes.configPaper} >
            <Box width={3 / 4} className={classes.mBottom} >
                <FormControl>
                    <FormControlLabel
                        value="Enabled"
                        control={<Switch size="small" color="secondary" onClick={(e) => setEnabled(!enabled)} disabled checked={enabled} />}
                        label="Enabled"
                        labelPlacement="right"
                    />
                </FormControl>
            </Box>
            <Box width={3 / 4} className={classes.mBottom}>
                <FormControl>
                    <FormControlLabel
                        value="Coupon Active"
                        control={<Switch size="small" color="secondary" onClick={(e) => setVisible(!visible)} disabled={!isAdmin} checked={visible} />}
                        label="Visible"
                        labelPlacement="right"
                    />
                </FormControl>
            </Box>
            <Box width={3 / 4} className={classes.mBottom}>
                <FormControl>
                    <FormControlLabel
                        value="Coupon Active"
                            control={<Switch size="small" color="secondary" onClick={(e) => setForceOpen(!forceOpen)} disabled={!isAdmin} checked={forceOpen} />}
                        label="Force Open"
                        labelPlacement="right"

                    />
                </FormControl>
            </Box>
        </Paper>
        <Paper elevation={2} className={classes.configPaper} >
            <Box width={1} className={classes.mBottom}>
                <InputLabel id="demo-customized-select-label">Stream</InputLabel>
                <TextField
                    fullWidth={true}
                    value={contentUrl}
                    disabled={!isAdmin}
                    onChange={(event) => { setContentUrl(event.target.value) }}
                />
            </Box>
            <Box width={1} className={classes.mBottom}>
                <InputLabel id="demo-customized-select-label">App id</InputLabel>
                <TextField
                    fullWidth={true}
                    value={appid}
                    InputProps={{
                        readOnly: true,
                    }}
                    disabled={true}
                    onChange={(event) => { setAppid(event.target.value) }}
                />
            </Box>
        </Paper>
       
        <Paper elevation={2} className={classes.configPaper} >
            <Box width={1 / 2} className={classes.mBottom}>
                <InputLabel id="demo-customized-select-label">Collection Id</InputLabel>
                <TextField
                    fullWidth={true}
                    value={collectionId}
                    onChange={(event) => { setCollectionId(event.target.value) }}
                    disabled={!isAdmin}
                />
            </Box>
        </Paper>
        
        <Paper elevation={2} className={classes.configPaper} >
            <Box width={3 / 4} className={classes.mBottom}>
                <FormControl>
                    <FormControlLabel
                        value="Show Coupon"
                        control={<Switch size="small" color="secondary" disabled={!isAdmin} onClick={(e) => setShowCoupon(!showCoupon)} checked={showCoupon} />}
                        label="Show Coupon"
                        labelPlacement="right"

                    />
                </FormControl>
            </Box>
            <Box width={1} className={classes.mBottom}>
                <InputLabel id="demo-customized-select-label">Coupon Code</InputLabel>
                <TextField
                    fullWidth={true}
                    value={couponCode}
                    disabled={!isAdmin}
                    onChange={(event) => { setCouponCode(event.target.value) }}
                />
            </Box>
        </Paper>
        <Paper elevation={2} className={classes.configPaper} >
            <Box width={1 / 2} className={classes.mBottom}>
                <FormControl className={classes.cien} >
                    <InputLabel id="tipo">Chat Layout</InputLabel>
                    <Select
                        id="tipo"
                        value={chatLayout}
                        onChange={(event) => setChatLayout(event.target.value)}
                        disabled={!isAdmin}
                    >
                        <MenuItem value={'overlay'}>
                            overlay
                        </MenuItem>
                        <MenuItem value={'sidebar'}>
                            sidebar
                        </MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Paper>
        <Box width={1} className={classes.mBottom}>
            <Button onClick={() => guardarCambios()} variant="contained" color="primary">
                Guardar Cambios
            </Button>
        </Box>

         
    </div>
    )
}

export default ConfigOptions;
